import {
  format,
  addMinutes,
  subMinutes,
  eachDayOfInterval,
  eachHourOfInterval,
  addMonths,
  addYears,
} from 'date-fns';

export const timeZoneSafeDate = (date, timeRange, isEndDate = false) => {
  const adjustDate = !isEndDate || (isEndDate && timeRange !== 'lastSevenDays');
  if (!adjustDate) return date;

  const dateTZO = date.getTimezoneOffset();
  return dateTZO >= 0 ? subMinutes(date, Math.abs(dateTZO)) : addMinutes(date, Math.abs(dateTZO));
};

export const getYearlyLabels = (startDate, diffInYears) => {
  const labels = [];

  for (let i = 0; i <= diffInYears; i++) {
    const yearDate = addYears(startDate, i);
    const yearName = format(yearDate, 'yyyy');
    labels.push({ value: yearName, isoValue: yearDate.toISOString() });
  }

  return labels;
};

export const getMonthlyLabels = (startDate, diffInMonths) => {
  const labels = [];

  for (let i = 0; i <= diffInMonths; i++) {
    const monthDate = addMonths(startDate, i);
    const monthName = format(monthDate, 'MMMM');
    labels.push({ value: monthName, isoValue: monthDate.toISOString() });
  }

  return labels;
};

export const getDailyLabels = (startDate, endDate) => {
  return eachDayOfInterval({
    start: startDate,
    end: endDate,
  }).map((day) => ({
    value: format(day, 'MMM d'),
    isoValue: day.toISOString(),
  }));
};

export const getWeekDayLabels = (startDate, endDate) => {
  return eachDayOfInterval({
    start: startDate,
    end: endDate,
  }).map((day) => ({
    value: format(day, 'EEEE'),
    isoValue: day.toISOString(),
  }));
};

export const getHourlyLabels = (startDate, endDate) => {
  return eachHourOfInterval({
    start: startDate,
    end: endDate,
  }).map((hour) => ({
    value: format(hour, 'H'),
    isoValue: hour.toISOString(),
  }));
};

export const normalizeTimeString = (time) => (time < 10 ? `0${time}` : time);
